<app-universal-modal-template
  [state]="state()"
  [showCloseButton]="false"
  (closeEvent)="close()"
>
  @if (content(); as c) {
    <div class="flex flex-col gap-4 px-5 pb-9 pt-6">
      <div class="flex items-center justify-between">
        @if (c.cancelButton) {
          <app-button
            [config]="c.cancelButton"
            (action)="close()"
          />
        }
        @if (c.doneButton) {
          <app-button
            [config]="c.doneButton"
            (action)="confirm()"
          />
        }
      </div>

      <ion-picker>
        <ion-picker-column
          [value]="currentValue()"
          (ionChange)="onPickerChange($event)"
        >
          @for (state of states; track state) {
            <ion-picker-column-option [value]="state"> {{ state }} </ion-picker-column-option>
          }
        </ion-picker-column>
      </ion-picker>
    </div>
  }
</app-universal-modal-template>
